module.exports = __webpack_public_path__ + "img/buyer-insights.a396a0f3.png";